// extracted by mini-css-extract-plugin
export default {"offerNotFound":"XEnqKMcQu2","offerLocation":"dO2S6L2yuA"};